import { Role } from "@/features/auth/authContext";
import { useCurrentUser } from "@/features/auth/useCurrentUser";

interface RoleGateProps {
  roles: Role[];
  children: React.ReactNode;
}

export function RoleGate({ roles, children }: RoleGateProps) {
  const user = useCurrentUser();
  if (!user) {
    console.error("User is not found.");
    return null;
  }
  if (roles.some((role) => (user.roles ?? []).includes(role))) {
    return children;
  }
  return null;
}
